import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getServicesForAddClientService = async (token, options = {}) => {
    log("welcome in getServicesForAddClientService")

    if (!token || token === "") {
        alert("No token in getServicesForAddClientService")
        return {error: true, message: "No token provided", services: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_services_for_add_client_service_api'
        log("url=" + url)

        // Build query params
        const params = {}

        // Target client ID (the client we're adding service to)
        if (options.target_client_id) {
            params.target_client_id = options.target_client_id
        }

        // Service type filter
        if (options.service_type_id) {
            params.service_type_id = options.service_type_id
        }

        // Include subclients
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getServicesForAddClientService")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getServicesForAddClientService")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getServicesForAddClientService", services: []}
    }
}

const useGetServicesForAddClientService = () => {
    return {error, getServicesForAddClientService}
}

export default useGetServicesForAddClientService
